export const IS_APP_BANNER_DISMISSED_KEY = 'isAppBannerDismissed';
